import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Wallet } from '@/core/services/Wallets/WalletInterface'
import { cn } from '@bem-react/classname'

import { Card } from '@/components/UI/Card'
import { Exchange } from '@/components/UI/Exchange'

import { CryptoSlider } from '../CryptoSlider'
import './Hero.scss'

const cnHero = cn('Hero')

interface HeroProps {
  className?: string
  data: Wallet[]
}

export const Hero: FC<HeroProps> = ({
  className,
  data,
}: HeroProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <div className={cnHero(null, [className])}>
      <div className={cnHero('wrap')}>
        <div className={cnHero('title')}>{t('landing-hero-title')}</div>
        <CryptoSlider data={data} />
      </div>

      <Card>
        <Exchange className={cnHero('exchange')} />
      </Card>
    </div>
  )
}
